"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "columnName"];
var styles = function styles(theme) {
  return {
    root: {
      paddingTop: _tokens.spacing20,
      paddingBottom: _tokens.spacing20
    },
    head: {
      color: theme.palette.grey[500],
      fontSize: _tokens.fontSizeSmall,
      fontWeight: 500,
      lineHeight: _tokens.lineHeightHeader3
    },
    paddingCheckbox: {
      paddingRight: 0,
      paddingLeft: _tokens.spacing20
    },
    body: {},
    stickyHeader: {
      backgroundColor: theme.palette.grey[100]
    }
  };
};

/**
 * Table cell
 */
var TableCell = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    columnName = props.columnName,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = (0, _extends2.default)({
    root: classes.root,
    head: classes.head,
    body: classes.body,
    paddingCheckbox: classes.paddingCheckbox
  }, classes);
  return /*#__PURE__*/_react.default.createElement(_TableCell.default, (0, _extends2.default)({}, rest, {
    "data-label": columnName || '',
    classes: classOverrides,
    ref: ref
  }));
});
TableCell.muiName = 'TableCell';
TableCell.displayName = 'TableCell';
TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content. Monetary or generally number fields should
   * be right aligned as that allows you to add them up quickly in your head without having
   * to worry about decimals.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'right', 'center', 'justify']),
  /**
   * The table cell contents
   */
  children: _propTypes.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.elementType,
  /**
   * Sets the padding applied to the cell.
   */
  padding: _propTypes.default.oneOf(['normal', 'checkbox', 'none', 'default']),
  /**
   * Set scope attribute.
   */
  scope: _propTypes.default.string,
  /**
   * Specify the size of the cell. By default, inherits `size` from the parent `Table`.
   */
  size: _propTypes.default.oneOf(['small', 'medium']),
  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),
  /**
   * 	The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * Specify the cell type. By default, the `TableHead`, `TableBody` or `TableFooter` parent component set the value.
   */
  variant: _propTypes.default.oneOf(['head', 'body', 'footer']),
  /**
   * Set this if you want to render a responsive Table
   */
  columnName: _propTypes.default.string
};

// default props
TableCell.defaultProps = {
  align: 'inherit',
  padding: 'normal'
};
var _default = (0, _styles.default)(styles)(TableCell);
exports.default = _default;